import {
  CloudChangeV2,
  type CustomCloudOptions,
  CloudAccountChangeV2,
  type CloudAccountChangeParams,
} from '@labrav/common'
import {
  ButtonV2,
  LabraToolTipV2,
  type CloudAccountType,
} from '@labrav/react-components'
import type { Dispatch, SetStateAction } from 'react'
import { useStyles } from './ReceivedResellerAuthorizations.styles'

type CloudAndCreateChannelOfferProps = {
  externalBaseURL?: string
  customCloudSelectorOptions: CustomCloudOptions
  setInputValue: Dispatch<SetStateAction<string>>
  setShowCrossMark: Dispatch<SetStateAction<boolean>>
  setSearchNow: Dispatch<SetStateAction<boolean>>
  marketplaceCloudAccounts: CloudAccountType[]
  selectedAccountIdWithCloud: string
  handleCloudAccountChange: (params: CloudAccountChangeParams) => void
  onCreateChannelOffer: () => void
}

export const CloudAndCreateChannelOffer = ({
  externalBaseURL,
  customCloudSelectorOptions,
  setInputValue,
  setShowCrossMark,
  setSearchNow,
  marketplaceCloudAccounts,
  selectedAccountIdWithCloud,
  handleCloudAccountChange,
  onCreateChannelOffer,
}: CloudAndCreateChannelOfferProps) => {
  const { classes } = useStyles()
  return (
    <div className={classes.dropdownAndProduct}>
      <div>
        {externalBaseURL ? (
          <CloudChangeV2
            customCloudOptions={customCloudSelectorOptions}
            setInputValue={setInputValue}
            setShowCrossMark={setShowCrossMark}
            setSearchNow={setSearchNow}
          />
        ) : (
          <CloudAccountChangeV2
            cloudAccounts={marketplaceCloudAccounts}
            selectedAccountId={selectedAccountIdWithCloud}
            onChange={handleCloudAccountChange}
            width={220}
            size="small"
          />
        )}
      </div>
      <LabraToolTipV2 tooltipPlacement="bottom" description="">
        <ButtonV2
          variant="contained"
          styleType="primary"
          smallVariant
          onClick={onCreateChannelOffer}
          data-testid="create-cppo-from-resale-auth"
        >
          Create channel offer
        </ButtonV2>
      </LabraToolTipV2>
    </div>
  )
}
